import { Box, Typography } from '@customink/pigment-react';
import { styled } from '@customink/pigment-react/lib/themeCustomink';
import type { ProjectItem } from '@customink/project-service-types';
import type { MouseEvent } from 'react';

const StyledLink = styled(Typography)({
  color: 'rgba(0, 0, 0, 0.57)',
  textDecoration: 'underline',
  cursor: 'pointer',
});

type GroupItemActionsProps = {
  hasLineup: boolean;
  compact?: boolean;
  onDelete: (e: MouseEvent<HTMLSpanElement>) => void;
  onViewSizingGuide: (e: MouseEvent<HTMLSpanElement>) => void;
  groupItemCount: number;
};

export function GroupItemActions({
  hasLineup,
  compact,
  groupItemCount,
  onDelete,
  onViewSizingGuide,
}: GroupItemActionsProps) {
  return (
    <Box
      alignItems={compact ? 'center' : 'flex-end'}
      data-testid="group-item-actions"
      display="flex"
      flexDirection={compact ? 'row' : 'column'}
      flexWrap="wrap"
      gap={compact ? '0.25rem 1rem' : '0.25rem'}
    >
      {groupItemCount > 1 && (
        <StyledLink
          onClick={onDelete}
          sx={{ order: compact ? 2 : 1 }}
          variant="uiTextSmall"
        >
          Remove
        </StyledLink>
      )}
      {hasLineup && (
        <StyledLink
          onClick={onViewSizingGuide}
          sx={{ order: 1 }}
          variant="uiTextSmall"
        >
          View sizing guide
        </StyledLink>
      )}
    </Box>
  );
}
